axios = require('axios');

const AUTH_ENDPOINT = '/auth';
const GET_USER_DATA = '/get_user_data';
const SET_USER_VIEW_SETTING = '/set_user_view_setting';
const LOGOUT = '/logout';

const API_ROOT = '/api/v1';

// note: no_proxy_cache_urls = {GET_USER_DATA: 1} does not do what we want.. it
// uses the name of GET_USER_DATA as the keyname (instead of the value)
const no_proxy_cache_urls = {};
no_proxy_cache_urls[GET_USER_DATA] = 1;


// export default var api = {

class Api {
  constructor() {

  }

  // retrieve user data for an already logged in user. Returns a promise that can
  // resolved to the user data.
  get_user_data(payload) {
    return axios({
      url: GET_USER_DATA,
      method: 'GET',
      headers: {
        'X-Auth-JWT': payload.token,
        'Cache-Control': 'private,max-age=3600',
      },
    });
  }

  // Authenticate the user with the backend, and return a promise that resolves
  // to the login jwt token. This token can be used when retreiving user data.
  // (This method also has the side-effect of setting a http-only token, that
  // will subsequently be send for all requests.
  authenticate_user(username, password) {
    return axios({
      url: AUTH_ENDPOINT,
      method: 'POST',
      responseType: 'json',
      data: {
        username,
        password,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  logout_user() {
    return axios({
      url: LOGOUT,
      method: 'POST',
      responseType: 'json',
    });
  }

  get_api_route(service, extra_path = '') {
    return `${API_ROOT}/${service}${extra_path}`;
  }

  get_item(service, id) {
    const api_route = this.get_api_route(service);
    return axios({
      url: api_route,
      method: 'GET',
      params: {
        id,
      },
      responseType: 'json',
    });
  }

  get_suggestion(service, q) {
    const api_route = this.get_api_route(service, '/suggest');
    return axios({
      url: api_route,
      method: 'GET',
      params: {
        q,
      },
      responseType: 'json',
    });
  }
}

// intercept all requests in no_proxy_cache_calls, and add in a cache-busting
// query parameter to them.
axios.interceptors.request.use((config) => {
  if (no_proxy_cache_urls[config.url]) {
    params = config.params || {};
    params.cb = localStorage.getItem('cache_busting_arg') || guid();
    config.params = params;
  }

  return config;
}, error => Promise.reject(error));

export default new Api();
